import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useChargePointChannelPhysicalSocketContext } from '../../charge-point.context';

export const ChargePointChannelPhysicalSocketDeleteFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const physicalSocket = useChargePointChannelPhysicalSocketContext();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <>
        <Text bold>
          {t('$.charge-point-channel-physical-socket-delete.step-1.confirm', {
            physicalSocketId: physicalSocket.id,
          })}
        </Text>
        <Text italic>
          {t('$.charge-point-channel-physical-socket-delete.step-1.warning')}
        </Text>
      </>
    );
  };
